import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_vbyfesg45s: FaireBrandEntity = {
  token: "b_vbyfesg45s",
  type: "brand",
  name: "Anders Ruff Design Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/b8315a7cf8f8c6fa6f0890227a0944c45e305278a76210a641d9b1c80438b813.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/b263dcd775c889f42cd4905c9c24c19c08682ae82618b605418cd4a315c5f692.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/b8315a7cf8f8c6fa6f0890227a0944c45e305278a76210a641d9b1c80438b813.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/b263dcd775c889f42cd4905c9c24c19c08682ae82618b605418cd4a315c5f692.jpeg",
  location: "Pineville, NC, USA",
  minimumOrderDollars: 200,
  rating: 4.8,
  reviewCount: 10,
  isInsider: true,
  description:
    "Anders Ruff Design Co. exists to connect our passion for creativity with a desire to share that joy with others, bringing together inspired accessories, party printables, and beautifully designed décor for those who embrace a celebrate-everyday mindset.  Co-creators and founders, Maureen Anders and Adria Ruff, have built a brand rooted in trend-forward design, whimsical details, and thoughtful gifting. \n\nWe are proudly Mahjong-obsessed, and our newest Mahjong line introduces fresh, elevated designs to this timeless and beloved game. We design a wide range of Mahjong accessories—from tiles, mats and table linens to storage, lighting, and more—blending style, function, and a touch of playful luxury.\n\nThrough our sister company, AR Workshop, also developed by the same creative duo, we bring these designs to life in our boutique workshop studios and mobile Crafty Cruiser experiences across the country. Whether you’re crafty or not, you can join us to create something meaningful in an inspiring, hands-on environment.  ✨ Experience us live—find a location near you through AR Workshop.\n\nAnders Ruff Design Co. extends this creative spirit into your home through our curated collections available on Faire and beyond. We’re so glad you’re here—and we can’t wait to show you what’s next.\n",
  meta: {
    source: "api",
    importedAt: "2026-07-17T18:40:36.717Z",
    importedBy: "entity-db-cli",
  },
};
